import React, { useEffect, useRef } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const SunTextEditor = ({ value, onChange,height = 150}) => {
  const editorRef = useRef();

  // Initialize editor once
  useEffect(() => {
    return () => {
      // Properly destroy SunEditor on unmount
      if (editorRef.current?.editor) {
        try {
          editorRef.current.editor.destroy();
        } catch (err) {
          console.warn("SunEditor cleanup issue:", err);
        }
      }
    };
  }, []);

  return (
    <SunEditor
      ref={editorRef}
      setContents={value || ""}
      onChange={(content) => onChange(content)}
      setOptions={{
        height: 200,
        height: `${height}px`,            // ✅ Controls iframe height
        minHeight: `${height}px`,
        maxHeight: `${height}px`,
        resizingBar: false,
        buttonList: [
          ["undo", "redo", "font", "fontSize", "formatBlock"],
          ["bold", "underline", "italic", "strike", "subscript", "superscript"],
          ["fontColor", "hiliteColor", "textStyle"],
          ["removeFormat"],
          ["outdent", "indent", "align", "horizontalRule", "list", "table"],
          ["link", "image", "video"],
          ["fullScreen", "showBlocks", "codeView", "preview", "print"],
        ],
      }}

    />
  );
};

export default React.memo(SunTextEditor);
